import { Button, Grid, Paper } from "@mui/material";
import React from "react";

const TaskTableAction = ({ selectedRows, selectedTab, handleArchiveTasks }) => {
  return (
    <Grid container justifyContent="center" className="trans-table__process">
      {["active", "automated", "audited"].includes(selectedTab) && (
        <Grid item sm={3} lg={3}>
          <Paper
            style={{ padding: "10px 12px", borderRadius: "4px" }}
            component={Grid}
            display="flex"
            justifyContent="space-between"
          >
            <Button
              color="primary"
              variant="outlined"
              style={{
                borderRadius: "50px",
                fontSize: "14px",
                lineHeight: "20px",
                fontWeight: 400,
                padding: "10px 15px !important",
                color: "#757575",
                borderColor: "#E0E0E0",
              }}
            >
              {selectedRows} Selected
            </Button>
            <Button variant="text" color="inherit" onClick={handleArchiveTasks}>
              Archive Tasks
            </Button>
          </Paper>
        </Grid>
      )}
    </Grid>
  );
};

export default TaskTableAction;
